interface VideoProgressButtonProps {
  progress: number;
  isPlaying: boolean;
  onToggle: () => void;
  className?: string;
  trackClassName?: string;
  size?: number;
  strokeWidth?: number;
}

export default function VideoProgressButton({
  progress,
  isPlaying,
  onToggle,
  className = 'text-green-50 hover:text-green-60',
  trackClassName = 'stroke-green/25',
  size = 32,
  strokeWidth = 3.6,
}: VideoProgressButtonProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const pauseIconWidth = size * 0.47;
  const pauseIconHeight = size * 0.47;
  const playIconWidth = size * 0.56;
  const playIconHeight = size * 0.56;

  // Calculate the offset for the progress circle (same as CircularLoadingIndicator)
  const offset = circumference - progress * circumference;

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`group relative inline-flex cursor-pointer items-center justify-center transition-colors ${className}`}
      style={{ width: size, height: size }}
      aria-label={isPlaying ? 'Pause video' : 'Play video'}
    >
      <svg width={size} height={size} className="-rotate-90 transform">
        {/* Background circle (green transparent) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="transparent"
          className={`transition-colors ${trackClassName}`}
        />
        {/* Progress circle (green) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="square"
          className="transition-all duration-300 ease-in-out"
        />
      </svg>
      {/* Play/Pause icon */}
      <div className="absolute inset-0 flex items-center justify-center transition-colors">
        {isPlaying ? (
          <svg
            width={pauseIconWidth}
            height={pauseIconHeight}
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <rect x="2" y="1" width="3" height="10" rx="1" />
            <rect x="7" y="1" width="3" height="10" rx="1" />
          </svg>
        ) : (
          <svg
            width={playIconWidth}
            height={playIconHeight}
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <path d="M3 1.5v9l7-4.5-7-4.5z" />
          </svg>
        )}
      </div>
    </button>
  );
}
